import React from 'react';

import PageLayout from '../../components/blocks/page-layout';
import { useTranslate } from '../../hooks/useTranslate';
import { useLocale } from '../../hooks/useLocale';
import { PrivacyPolicyNl } from '../../policies/privacy-nl';
import { PrivacyPolicyFr } from '../../policies/privacy-fr';

export default function Page() {
  const translate = useTranslate();
  const locale = useLocale();

  return (
    <PageLayout title={translate('policies.privacyPolicy')}>
      {locale === 'fr' ? <PrivacyPolicyFr /> : <PrivacyPolicyNl />}
    </PageLayout>
  );
}
